import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
} from "reactstrap";

const UserDetailsModal = ({ isOpen, toggle, user, loading, error }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered scrollable size="lg">
      <ModalHeader
        className="d-flex align-items-center"
        toggle={toggle}
        style={{ background: "#E0F8E0" }}
      >
        User Details
      </ModalHeader>
      <ModalBody>
        {loading && <p className="text-muted">Loading...</p>}
        {error && <p className="text-danger">Error: {error}</p>}

        {user && (
          <>
            {/* Profile Picture & Basic Info */}
            <Row className="align-items-center mb-4">
              {/* <Col md={4} className="text-center">
                <img
                  src={user?.profilePic}
                  alt="Profile"
                  className="img-thumbnail rounded-circle"
                  style={{
                    height: "150px",
                    width: "150px",
                    objectFit: "cover",
                  }}
                />
              </Col> */}

              <Col md={4} className="text-center">
                {user?.profilePic ? (
                  <img
                    src={user?.profilePic}
                    alt="Profile"
                    className="img-thumbnail rounded-circle"
                    style={{
                      height: "150px",
                      width: "150px",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle bg-success text-white fw-bold"
                    style={{
                      height: "150px",
                      width: "150px",
                      fontSize: "48px",
                    }}
                  >
                    {user?.name
                      ? user.name
                          .split(" ")
                          .filter(Boolean)
                          .map((word) => word[0])
                          .join("")
                          .toUpperCase()
                      : ""}
                  </div>
                )}
              </Col>

              <Col md={8}>
                <h5 className="fw-semibold mb-3">{user?.name}</h5>
                <Row>
                  <Col md={6}>
                    {/* <p className="mb-1">
                      <strong>Name:</strong> {user?.name || user?.username}
                    </p> */}
                    <p className="mb-1">
                      <strong>Email:</strong> {user?.email}
                    </p>
                    <p className="mb-1">
                      <strong>Phone:</strong> {user?.mobileNo || "-"}
                    </p>
                    <p className="mb-1">
                      <strong>Address:</strong> {user?.address}
                    </p>
                    <p className="mb-1">
                      <strong>Joining Date:</strong> {user?.joineDate}
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>

            <hr />

            <Row>
              <Col md={6}>
                <h5 className="fw-semibold mb-3">Diet & Medical Summary</h5>
                <p className="mb-1">
                  <strong>Age:</strong> {user?.age}
                </p>
                <p className="mb-1">
                  <strong>Gender:</strong> {user?.gender}
                </p>
                <p className="mb-1">
                  <strong>Height:</strong> {user?.height} cm
                </p>
                <p className="mb-1">
                  <strong>Weight:</strong> {user?.weight} kg
                </p>

                {user.allergies?.length > 0 && (
                  <p className="mb-1">
                    <strong>Allergies:</strong>{" "}
                    {user?.allergies.map((a) => a?.allergiesName).join(", ")}
                  </p>
                )}

                {user.medicalConditions?.length > 0 && (
                  <p className="mb-1">
                    <strong>Medical Conditions:</strong>{" "}
                    {user?.medicalConditions.join(", ")}
                  </p>
                )}

                {user?.dietaryPreferences?.length > 0 && (
                  <p className="mb-1">
                    <strong>Dietary Preferences:</strong>{" "}
                    {user?.dietaryPreferences
                      .map((d) => d?.dietaryPreferencesName)
                      .join(", ")}
                  </p>
                )}
              </Col>
            </Row>

            {user?.subscription && (
              <>
                <hr />
                <Card className="bg-light border-0 shadow-sm">
                  <CardBody>
                    <h5 className="fw-semibold mb-3">
                      Subscription Plan Details
                    </h5>
                    <Row>
                      <Col md={6}>
                        <p className="mb-1">
                          <strong>Plan Name:</strong>
                          {user?.subscription?.planName}
                        </p>
                        <p className="mb-1">
                          <strong>Price:</strong> ₹
                          {user?.subscription?.planPrice}
                        </p>
                        <p className="mb-1">
                          <strong>Discount:</strong> ₹
                          {user?.subscription?.planDiscount}
                        </p>
                      </Col>
                      <Col md={6}>
                        <p className="mb-1">
                          <strong>Duration:</strong>
                          {user?.subscription?.planDurationInDays} days
                        </p>
                        <p className="mb-1">
                          <strong>Start Date:</strong>
                          {user?.subscription?.startDate}
                        </p>
                        <p className="mb-1">
                          <strong>End Date:</strong>
                          {user?.subscription?.endDate}
                        </p>
                        <p className="mb-1">
                          <strong>Status:</strong>
                          <Badge className="danger">
                            {user?.subscription?.status}
                          </Badge>
                        </p>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </>
            )}
          </>
        )}
      </ModalBody>

      <ModalFooter>
        <Button color="success" className="btn-sm" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UserDetailsModal;
